<app-landing-pages [dataId]="'testing-data'"></app-landing-pages>
